import { Component, inject, OnInit, output, signal } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ButtonComponent } from '../../primitives/button/button.component';
import { RowComponent } from '../../elements/row/row.component';
import { Browser } from '@capacitor/browser';
import { AmplitudeService } from 'src/app/services/amplitude.service';
import { NativeService } from 'src/app/services/native.service';

@Component({
    selector: 'app-profile-anonymous',
    templateUrl: './profile-anonymous.component.html',
    styleUrls: ['./profile-anonymous.component.scss'],
    imports: [ButtonComponent, RowComponent]
})
export class ProfileAnonymousComponent implements OnInit {
  private $amplitude = inject(AmplitudeService);
  private $native = inject(NativeService);

  public loginEvent = output<void>();

  public onMobile = signal<boolean>(false);
  public isWeb = this.$native.isWeb;

  ngOnInit() {
    this.onMobile.set(Capacitor.isNativePlatform());
  }

  login() {
    this.loginEvent.emit();
  }

  async getHelp() {
    await Browser.open({ url: 'https://www.chemist2u.com.au/app-help', presentationStyle: "popover" });
    this.$amplitude.track('OPEN_EXTERNAL_HELP');
  }

}